import IconLightBulb from "@fider/assets/images/heroicons-light-bulb.svg"

import IconLink from "@fider/assets/images/heroicons-link.svg"

import IconChat from "@fider/assets/images/heroicons-chat-alt-2.svg"

import IconSparkles from "@fider/assets/images/heroicons-sparkles-outline.svg"

// Tùy biến KHCN: icon cho từng hạng mục bài đăng, dùng chung cho điều hướng và menu vòng cung

export const CATEGORY_ICONS: { [slug: string]: SpriteSymbol } = {
  "y-tuong-khoi-nghiep": IconLightBulb,

  "giai-phap": IconLink,

  "nhu-cau-cong-nghe": IconSparkles,

  "gop-y-trao-doi": IconChat,
}